import Panel from '../components/panel'
import {Button} from '../components//button'
import PropertyInput from "../components/inputs/input-property.tsx";

import { useStore } from "../state/state.ts";
import { ModalClose } from '../components/modal-close.tsx';


export default function ModalInfoHeizkosten() {
    const pop_modal = useStore((state)=>state.pop_modal);
    
  return (<Panel >
            <h1 id="modal-title">Heizkosten</h1>
            <p id="modal-description">Bei Wechsel von z. B. Öl oder Gas auf eine Wärmepumpe fallen zukünftig Kosten für den Wärmepumpenstrom an.</p>
             <ModalClose label={"schließen"} onClick={()=>{
                            pop_modal();
                        }}/>
         </Panel>)
}

